import {
  SurveyReportDetailPage,
  SurveyReportListPage,
} from 'apps/hub/components/SurveyReports/pages';
import { SURVEY_REPORT_TYPE } from 'apps/hub/components/SurveyReports/constants';
import { Navigate, useParams } from 'react-router-dom';

const LegacyFHCReportRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/hub/survey-reports/${id}`} replace />;
};

const hubRoutes = [
  { path: '/hub/survey-reports', element: <SurveyReportListPage /> },
  { path: '/hub/survey-reports/:id', element: <SurveyReportDetailPage /> },
  // Legacy /hub/fhc-reports links land on the health check (1002) filter.
  {
    path: '/hub/fhc-reports',
    element: (
      <Navigate
        to={`/hub/survey-reports?type=${SURVEY_REPORT_TYPE.INVESTMENT_HEALTHCHECK}`}
        replace
      />
    ),
  },
  { path: '/hub/fhc-reports/:id', element: <LegacyFHCReportRedirect /> },
];

export default hubRoutes;
